class ScxLightboxOpener extends HTMLElement {
  constructor() {
    super();
    this.lb = document.querySelector("#product-lightbox");
    this.scxSwiper = document.querySelector("scx-swiper");
  }

  connectedCallback() {
    this.addEventListener("click", (event) => {
      if (window.innerWidth <= 750) {
        return;
      }

      const trigger = event.target.closest("[data-index]");

      if (!trigger) return;

      const index = Number(trigger.dataset.index);

      if (!isNaN(index)) {
        this.scxSwiper.setAttribute("data-is", index);
        this.scxSwiper.openAtIndex(index);
        this.lb?.setAttribute("open", "");
        document.body.classList.add("drawer-container");
      }
    });
  }
}

customElements.define("scx-lightbox-opener", ScxLightboxOpener);
